import { Icon, IconName, IconSize, IconVariant, TD, TR } from "@quortex/front-common"

const ArrowTR = () => (
  <TR>
    <TD className="h-auto! p-0!" />
    <TD className="h-auto! px-0! py-xs!">
      <div className="flex w-[22rem] justify-center text-grey-600">
        <Icon icon={IconName.ARROW_DOWN} size={IconSize.MEDIUM} type={IconVariant.REGULAR} />
      </div>
    </TD>
  </TR>
)

export default ArrowTR
